import { createStore, applyMiddleware, compose } from "redux";
import promiseMiddleware from "redux-promise-middleware";
import thunkMiddleware from "redux-thunk";
import reducer, { IRootState } from "shared/reducer";
import errorMiddleware from "shared/middleware/error-middleware";
import loggerMiddleware from "shared/middleware/logger-middleware";

const defaultMiddlewares = [
	thunkMiddleware,
	promiseMiddleware,
	errorMiddleware,
	loggerMiddleware
];

function composeMiddlewares(middlewares: any = []) {
	return compose(applyMiddleware(...defaultMiddlewares, ...middlewares));
}

export default function setupStore(
	initialState?: IRootState,
	middlewares = []
) {
	return createStore(reducer, initialState, composeMiddlewares(middlewares));
}
